export function getCurrency(video, channel) {
  const dealInfo = video?.dealInfo?.[0] || channel?.dealInfo?.[0];
  return dealInfo?.currency;
}
